/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import {
    CASILLA_AVATAR_DOS_DATOS,
    CASILLA_ESTADO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tarjeta_Indicador from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Indicador";
import ic_persona from '../../Recursos/ic_maletin.svg'
import ic_bandera from '../../Recursos/ic_bandera.svg'
import {theme} from "../../Tema";
import React, {useEffect, useRef, useState} from "react";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Barras_Horizontales_Nombre from "../../Modulo_Graficas/Graficas/Barras_Horizontales_Nombre";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import Mapa_Departamentos from "../../Modulo_Graficas/Graficas/Mapa_Departamentos";
import Tarjeta_Titulo_Subtitulo_Grafica_Alta
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Alta";
import Dialogo_Cliente from "../Dialogos/Dialogo_Cliente";
import {ad_departamento_estado} from "../Adaptadores/ad_departamento_estado";
import {obtenerDepartamentos} from "../../Modulo_Graficas/Graficas/Componentes/Mapa/Funciones/obtenerDepartamentos";
import {ManageSearch} from "@mui/icons-material";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {obtenerClienteDepartamento} from "../FuncionesExternas/obtenerClienteDepartamento";
import {contarPropiedadValor} from "../../Servicios/BD/Contadores/contarPropiedadValor";


const Seccion_Directorio = () => {
    const refe = useRef()
    const {alto} = useObtenerAlto({contenedor: refe})
    const {props, setData, setNumeroFilas, cargarNuevamente,} = useObtenerColleccionTabla2025({coleccion: 'clientes'})
    const [clientesDepartamento, setClientesDepartamento] = useState([])
    const [departamentos, setDepartamentos] = useState([])
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Cliente,
        titulo: 'Detalles Despacho',
        realizado: cargarNuevamente
    })
    const altoGraficas = 80


    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    useEffect(() => {

        obtenerDoc('departamentos', 'departamentos').then((dox) => {
            if (dox.res) {
                let deps = dox.data.departamentos
                setDepartamentos(deps)
                obtenerClienteDepartamento(deps).then((des) => {
                    setClientesDepartamento(des)
                })
            }
        })



    }, []);
    return (
        <Grid2 container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid2 container size={{xs: 12, sm: 12, md: 8}} sx={{height: {xs: 'auto', md: alto}}}>

                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Clientes'}
                        subtitulo={'Por Departamento'}
                        Grafica={Barras_Horizontales_Nombre}
                        marginTop={12}
                        height={altoGraficas}
                        series={
                            [{
                                name: 'Num Clientes',
                                data: clientesDepartamento.map((e) => e.cantidad)
                            }]
                        }

                        labels={clientesDepartamento.map((e) => e.nombre)}/>

                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 2}} ref={refe}>
                    <Tarjeta_Indicador icono={ic_persona} color={theme.palette.secondary.main} titulo={'Clientes'}
                                       valor={props.numeroFilas}/>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 2}}>
                    <Tarjeta_Indicador icono={ic_bandera} titulo={'Departamentos'} valor={departamentos.length}/>
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 8}}>
                    <Tabla_Filtro
                        nombre={'Clientes'}
                        descripcion={'Base de datos de clientes'}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 4}}>
                    <Tarjeta_Titulo_Subtitulo_Grafica_Alta
                        titulo={'Clientes'}
                        subtitulo={'Por Departamento'}
                        Grafica={Mapa_Departamentos}
                        marginTop={0}
                        height={250}
                        series={clientesDepartamento}
                        labels={['uno', 'dos', 'tres', 'cuatro']}/>
                </Grid2>


            </Grid2>

        </Grid2>
    )

}


export default Seccion_Directorio

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
    {
        nombre: 'Ciudad',
        direccion: 'desc',
        propiedad: 'ciudad'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedadUno: 'img',
        propiedadDos: 'nombre',
        propiedadTres: 'razon',
        tipo: CASILLA_AVATAR_DOS_DATOS

    },
    {
        nombre: 'Departamento',
        direccion: 'right',
        propiedad: 'departamento',
        tipo: CASILLA_ESTADO,
        estados: ad_departamento_estado(obtenerDepartamentos())
    },
    {
        nombre: 'Ciudad',
        direccion: 'right',
        propiedad: 'ciudad',
        decimales: 0,
    }


]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]
